import { type CertificateProgramEngagementCta } from '@mc/api'
import { EngagementCTA } from 'pages/certificates/components/EngagementActionBlock/EngagementCTA'

type SubscriptionMemberNoteProps = {
  // The BE engagement note copy (details.text) and its "Start Course" link
  // (action_type START_TRIAL), rendered verbatim from the BE.
  text: string
  link: CertificateProgramEngagementCta
  certUuid: string
}

export const SubscriptionMemberNote = ({
  text,
  link,
  certUuid,
}: SubscriptionMemberNoteProps) => (
  <p className='c-body-small text-c-text-tint-3'>
    {text}
    <EngagementCTA
      action={link}
      certUuid={certUuid}
      setShowSyllabusModal={() => {}}
    />
  </p>
)
